//! Get the saved theme color from local storage

export const useThemeColor = () => {
  const storedTheme = localStorage.getItem("brands-themes");
  const getThemeColor = storedTheme ? JSON.parse(storedTheme) : null;
  const getPrimaryColor = getThemeColor?.[0]?.data?.colors?.primary;

  return getPrimaryColor ?? "";
};

export const useBrandCode = () => {
  const storedTheme = localStorage.getItem("brands-themes");
  const getThemeData = storedTheme ? JSON.parse(storedTheme) : null;
  const brandCode = getThemeData?.[0]?.data?.brandCode;

  return brandCode ?? "";
};
